import { CheckCircle } from '@mui/icons-material';
import React from 'react';

const Success = ({ handleClose }) => {
  return (
    <>
      <CheckCircle color="success" sx={{ fontSize: 80, marginBottom: 2 }} />
      <p>I will get back to you oh so quickly!</p>
    </>
  );
};

export default Success;
